module.exports = __webpack_public_path__ + "static/img/ccpv.76665a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/psLock/ccpt/ccpv.jpg
// module id = DpFn
// module chunks = 0